import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';

export enum AttachmentMenuState {
  HIDDEN,
  VIEW,
  EDIT,
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    openAttachmentBubbleMenu: {
      openAttachmentBubbleMenu: () => ReturnType;
    };
    editAttachmentInBubbleMenu: {
      editAttachmentInBubbleMenu: () => ReturnType;
    };
    closeAttachmentBubbleMenu: {
      closeAttachmentBubbleMenu: () => ReturnType;
    };
  }
  interface Storage {
    attachmentBubbleMenuHandler: AttachmentBubbleMenuHandlerStorage;
  }
}

export interface AttachmentBubbleMenuHandlerStorage {
  state: AttachmentMenuState;
}

const AttachmentBubbleMenuHandler = Extension.create<{}, AttachmentBubbleMenuHandlerStorage>({
  name: 'attachmentBubbleMenuHandler',

  addStorage() {
    return {
      state: AttachmentMenuState.HIDDEN,
    };
  },

  addCommands() {
    return {
      openAttachmentBubbleMenu:
        () =>
        ({ editor, chain, dispatch }) => {
          if (editor.isActive('attachment')) {
            if (this.storage.state !== AttachmentMenuState.VIEW) {
              chain().extendMarkRange('attachment').focus().run();
            }
          }
          if (dispatch) {
            this.storage.state = AttachmentMenuState.VIEW;
          }
          return true;
        },
      editAttachmentInBubbleMenu:
        () =>
        ({ dispatch }) => {
          if (this.storage.state === AttachmentMenuState.EDIT) {
            return false;
          }
          if (dispatch) {
            this.storage.state = AttachmentMenuState.EDIT;
          }
          return true;
        },
      closeAttachmentBubbleMenu:
        () =>
        ({ commands, dispatch }) => {
          if (this.storage.state === AttachmentMenuState.HIDDEN) {
            return false;
          }
          commands.focus();
          if (dispatch) {
            this.storage.state = AttachmentMenuState.HIDDEN;
          }
          return true;
        },
    };
  },

  onSelectionUpdate() {
    if (this.storage.state === AttachmentMenuState.EDIT) {
      this.editor.commands.closeAttachmentBubbleMenu();
    } else if (this.storage.state === AttachmentMenuState.VIEW && !this.editor.isActive('attachment')) {
      this.editor.commands.closeAttachmentBubbleMenu();
    }
  },

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('handleClickAttachmentForMenu'),
        props: {
          handleClick: (view, pos, event) => {
            const target = event.target as HTMLElement;
            const attachmentEl = target.closest('[data-attachment-id]');

            if (attachmentEl && this.storage.state === AttachmentMenuState.HIDDEN) {
              this.editor.commands.openAttachmentBubbleMenu();
            } else {
              this.editor.commands.closeAttachmentBubbleMenu();
            }

            return false;
          },
        },
      }),
    ];
  },
});

export default AttachmentBubbleMenuHandler;
